import GameStatesEnum from "@/states/GameStatesEnum";
import { GameStateMachine, Signals} from "@/Imports";
import Facade from '@/Facade'
import Utils from "@base/utils/Utils";
import FormatData from "@/application/FormatData";
import {setStep} from "@/managers/comunication/socket/utils";
import IntegrationConfig from "@/IntegrationConfig";
import {toNumber} from "lodash";

export default class Model {
  constructor () {
    Facade.model = this
    this.start()

  }

  start() {
    this.randomTime = 1000
    this._currentBet1 = 0
    this._currentBet2 = 0
    this.planeStates = ['IDLE', 'FLY', 'EXPLODE']
    this.multipliersHistory = []
    this.roundStartTime = 0
    this.finalMultiplier = 0
    this.roundStartDelay = 0
    this.makeBetsTime = 0
    this.deltaTime = 0
    this.lastUpdateRoundStart = 0
    this.lastUpdateTime = 0
    this.isAuto = false
    this._totalWin = 0
    this.bonusMultiplier = 1
    this.currentFreebetsValue = 0
    this.autoCollect1 = 0
    this.autoCollect2 = 0
    this.autoBet1 = false
    this.autoBet2 = false
    this._freebets = null

    this.fb_bet = -1

    this.stateMachine = new GameStateMachine(this, GameStatesEnum)
    this.numbersFixed = 2
    this.stateMachine.setState(GameStatesEnum.OPEN_SOCKET)

    if (!IntegrationConfig.INTEGRATION_THREE_PI)
      this.stateMachine.setState(GameStatesEnum.LOADING)

    const value1 = {
      a: 0,
      b: 0,
      c: 0,
      bi: 0,
      u: 0,
    }
    this._playerState1 = value1
    const value2 = {
      a: 0,
      b: 0,
      c: 0,
      bi: 0,
      u: 0,
    }
    this._playerState2 = value2

    this.bonusesTimers = []

  }

  set initRawData (data) {
    this._initRawData = data
    this.casinoToken = data.ct || null
    this.sessionToken = data.t || null
    this.customerLogo = data.cl || null
    this.freebets = data.fb
    this.freebets = data.fb
    this.availableBets = data.a_b
    this.aka = data.aka
    this.b_h = data.b_h
    this.bc_2h = data.bc_2h
    this.spos = data.spos
    this.dcb = data.dcb || null
    this.np_e = data.np_e || null
    this.ns_url = data.ns_url
    this.chat = data.chat
    this.maxWin = data.ma_w
    this.multiplierUpdateTime = data.mcs
    this.minBet = data.mi_b
    this.maxBet = data.ma_b
    this.betStep = Number(data.b_t)
    this.bet1 = this.minBet
    this.bet2 = this.minBet
    this.currencyCode = Utils.hexToChar(data.c)
    this.screenBets = data.p_b
    this.playersState = data.ps
    this.playerCountry = data.pc && data.pc.toLowerCase()

    this.lobbyURL = data.lurl || ""
    this.historyUrl = data.hurl || ""
    this.collectStep = data.c_t
    this.minCollect = data.mi_m
    this.maxCollect = data.ma_m
    this.collectStep = data.c_t

    this.currentBet1 = Number(this.minBet)
    this.currentBet2 = Number(this.minBet)

    this.currentAutoCollect1 = this.playerState1.a || this.minCollect
    this.currentAutoCollect2 = this.playerState2.a || this.minCollect
    this.ac1 = this.playerState1.a > 0 ? true : false
    this.ac2 = this.playerState2.a > 0 ? true : false
    this.balance = Number((data.b).toFixed(this.numbersFixed))
    this.netBalance = (0).toFixed(this.numbersFixed);

    setStep(this.multiplierUpdateTime)

    Signals.modelInitStored.dispatch()
  }

  set spinRawData (data) {
  }

  set betPossible (value) {
    this._betPossible = value
    this.totalBetsList = []
    for (let i = 0; i < value.length; i++) {
      this.totalBetsList.push(FormatData.formatToCoins(Number(value[i])))
    }
  }

  setPlaneIdle() {
    this.planeState = this.planeStates[0]
  }

  setPlaneFly() {
    this.planeState = this.planeStates[1]
  }

  setPlaneExplode() {
    this.planeState = this.planeStates[2]
  }

  get betPossible () {
    return this._betPossible
  }


  set balance (value) {
    const currentBalance = this._balance;
    const netBalance = this.netBalance;
    let balanceChange = 0;
    let totalNetBalance = 0;
    if(currentBalance !== undefined){
      balanceChange = toNumber(value) - toNumber(currentBalance);
      totalNetBalance = toNumber(netBalance) + balanceChange;
    }
    this._balance = value
    this.netBalance = totalNetBalance
    this.balanceViewText = `${this.currencyCode}${FormatData.formatToFixed(value)}`
    this.netBalanceViewText = `${this.currencyCode}${FormatData.formatToFixed(totalNetBalance ?? 0)}`
    Signals.balanceUpdate.dispatch(this.balanceViewText)
  }

  get balance () {
    return this._balance
  }

  set currentBet1 (value) {
    this._currentBet1 = value
    const v = FormatData.formatToFixed(this._currentBet1)
    Signals.currentBetHasChanged.dispatch({side: 1, value: v})
  }

  get currentBet1() {
    return this._currentBet1
  }

  set currentBet2 (value) {
    this._currentBet2 = value
    const v = FormatData.formatToFixed(this._currentBet2)
    Signals.currentBetHasChanged.dispatch({side: 2, value: v})
  }

  get currentBet2() {
    return this._currentBet2
  }

  set currentAutoCollect1 (value) {
    this._currentAutoCollect1 = value
    const v = FormatData.formatToFixed(value)
    Signals.currentAutoCollectHasChanged.dispatch({side: 1, value: v})
  }

  get currentAutoCollect1() {
    return this._currentAutoCollect1
  }

  set currentAutoCollect2 (value) {
    this._currentAutoCollect2 = value
    const v = FormatData.formatToFixed(value)
    Signals.currentAutoCollectHasChanged.dispatch({side: 2, value: v})
  }

  get currentAutoCollect2() {
    return this._currentAutoCollect2
  }

  set ac1(value) {
    this._ac1 = value
  }

  set ac2(value) {
    this._ac2 = value
  }

  get ac1() {
    return this._ac1
  }

  get ac2() {
    return this._ac2
  }

  set autoBet1(value) {
    this._autoBet1 = value
  }

  set autoBet2(value) {
    this._autoBet2 = value
  }

  get autoBet1() {
    return this._autoBet1
  }

  get autoBet2() {
    return this._autoBet2
  }

  set setAutoBet1(value) {
    this._setAutoBet1 = value

    if(value > 0 || value == -1) {
      this.autoBet1 = true
    } else {
      this.autoBet1 = false
    }

    let event = new CustomEvent("updateAutoBet1", { detail: {value: value}})
    document.dispatchEvent(event)
  }

  set setAutoBet2(value) {
    this._setAutoBet2 = value

    if(value > 0 || value == -1) {
      this.autoBet2 = true
    } else {
      this.autoBet2 = false
    }
    let event = new CustomEvent("updateAutoBet2", { detail: {value: value}})
    document.dispatchEvent(event)
  }

  get setAutoBet1() {
    return this._setAutoBet1
  }

  get setAutoBet2() {
    return this._setAutoBet2
  }

  set setAutoCollect1(value) {
    this._setAutoCollect1 = value

    if(value > 0 || value == -1) {
      this.ac1 = true
    } else {
      this.ac1 = false
    }
    let event = new CustomEvent("updateAutoCollect1", { detail: {value: value}})
    document.dispatchEvent(event)
  }

  set setAutoCollect2(value) {
    this._setAutoCollect2 = value

    if(value > 0 || value == -1) {
      this.ac2 = true
    } else {
      this.ac2 = false
    }
    let event = new CustomEvent("updateAutoCollect2", { detail: {value: value}})
    document.dispatchEvent(event)
  }

  get setAutoCollect1() {
    return this._setAutoCollect1
  }

  get setAutoCollect2() {
    return this._setAutoCollect2
  }



  makeBet(side) {
    let amount = side == 1 ? Facade.model.currentBet1 : Facade.model.currentBet2

    let autoCollect

    if(amount <= this.balance) {
      if(side == 1) {
        autoCollect = Facade.model.ac1 ? Facade.model.currentAutoCollect1 : 0
        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
            makeBet1_BUTTON: {
              enable: false,
              visible: true
            }
          } }))
      }

      if(side == 2) {
        autoCollect = Facade.model.ac2 ? Facade.model.currentAutoCollect2 : 0
        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
            makeBet2_BUTTON: {
              enable: false,
              visible: true
            }
          } }))
      }
    }

    Signals.gameMessage.dispatch({
      message: 'bet',
      amount: amount,
      autoCollect: autoCollect,
      cell: side
    })


  }

  maxBet1() {
    let fb
    if(this.balance >= this.maxBet) {
      fb = this.maxBet
    } else {
      fb = ((this.balance * 100000000) - ((this.balance * 100000000) % (this.betStep * 100000000))  )  / 100000000
    }
    if(fb > 0) {
      this.currentBet1 = fb
    }
  }

  maxBet2() {
    let fb
    if(this.balance >= this.maxBet) {
      fb = this.maxBet
    } else {
      fb = ((this.balance * 100000000) - ((this.balance * 100000000) % (this.betStep * 100000000))  )  / 100000000
    }
    if(fb > 0) {
      this.currentBet2 = fb
    }
  }

  minBet1() {
    this.currentBet1 = this.minBet
  }

  minBet2() {
    this.currentBet2 = this.minBet
  }

  setMinCollect1() {
    this.currentAutoCollect1 = this.minCollect
  }

  setMinCollect2() {
    this.currentAutoCollect2 = this.minCollect
  }

  setMaxCollect1() {
    this.currentAutoCollect1 = this.maxCollect
  }

  setMaxCollect2() {
    this.currentAutoCollect2 = this.maxCollect
  }

  prevBet1(betStep) {
    const fb = (Math.round(this._currentBet1 * 100000000) - Math.round(betStep * 100000000)) / 100000000
    if(fb < this.minBet) {
      return
    }
    this.currentBet1 = fb
  }

  prevBet2(betStep){
    const fb = (Math.round(this.currentBet2 * 100000000) - Math.round(betStep * 100000000)) / 100000000
    if(fb < this.minBet) {
      return
    }
    this.currentBet2 = fb
  }

  prevCollect1(collectStep) {
    const fb = (Math.round(this.currentAutoCollect1 * 100000000) - Math.round(collectStep * 100000000)) / 100000000
    if(fb < this.minCollect) {
      return
    }
    this.currentAutoCollect1 = fb
  }

  prevCollect2(collectStep){
    const fb = (Math.round(this.currentAutoCollect2 * 100000000) - Math.round(collectStep * 100000000)) / 100000000
    if(fb < this.minCollect) {
      return
    }
    this.currentAutoCollect2 = fb
  }

  nextBet1(betStep) {
    const fb = (Math.round(this.currentBet1 * 100000000) + Math.round(betStep * 100000000)) / 100000000
    if(fb > this.maxBet || fb > this.balance) {
      return
    }
    this.currentBet1 = fb
  }

  nextBet2(betStep) {
    const fb = (Math.round(this.currentBet2 * 100000000) + Math.round(betStep * 100000000)) / 100000000
    if(fb > this.maxBet || fb > this.balance) {
      return
    }
    this.currentBet2 = fb
  }

  nextCollect1(collectStep) {
    const fb = (Math.round(this.currentAutoCollect1 * 100000000) + Math.round(collectStep * 100000000)) / 100000000
    if(fb > this.maxCollect) {
      return
    }
    this.currentAutoCollect1 = fb
  }

  nextCollect2(collectStep) {
    const fb = (Math.round(this.currentAutoCollect2 * 100000000) + Math.round(collectStep * 100000000)) / 100000000
    if(fb > this.maxCollect) {
      return
    }
    this.currentAutoCollect2 = fb
  }

  set playersState (value) {
    this._playersState = value
    if(value.u1 >= this._playerState1.u) {
      const value1 = {
        fbb: value.fbb1,
        a: value.a1,
        b: value.b1,
        c: value.c1,
        bi: value.bi1,
        u: value.u1,
      }
      this.playerState1 = value1
    }

    if(value.u2 >= this._playerState2.u) {
      const value2 = {
        fbb: value.fbb2,
        a: value.a2,
        b: value.b2,
        c: value.c2,
        bi: value.bi2,
        u: value.u2,
      }
      this.playerState2 = value2
    }
    Signals.playersStateChanged.dispatch()

    let event = new CustomEvent("playersState", {detail: {value: value}})
    document.dispatchEvent(event)
  }

  get playersState () {
    return this._playersState
  }

  set playerState1 (value) {
    this._playerState1 = value
    if(this._playerState1.b > 0) {
      this.betId1 = this._playerState1.bi
      Signals.setBetStatus.dispatch({side: 1, ps: this._playerState1})
    }
    this.auto1 = this._playerState1.a
  }

  set playerState2 (value) {
    this._playerState2 = value
    if(this._playerState2.b > 0) {
      this.betId2 = this._playerState2.bi
      Signals.setBetStatus.dispatch({side: 2, ps: this._playerState2})
    }
    this.auto2 = this._playerState2.a
  }

  get playerState1 () {
    return this._playerState1
  }

  get playerState2 () {
    return this._playerState2
  }

  collect(data) {
    const ps = data.d.ps
    if(this.playerState1.b > 0 && ps.b1 == 0) {
      Signals.setMakeBet.dispatch(1)
      if(Facade.model.setAutoCollect1 > 0) {
        Facade.model.setAutoCollect1--
      }
    }
    if(this.playerState2.b > 0 && ps.b2 == 0) {
      Signals.setMakeBet.dispatch(2)
      if(Facade.model.setAutoCollect2 > 0) {
        Facade.model.setAutoCollect2--
      }
    }

    this.totalWin = data.d.wa
    Signals.onWin.dispatch(data.d.wa)

    this.playersState = ps
  }

  cancel(ps) {
    if(this.playerState1.b > 0 && ps.b1 == 0) {
      Signals.setMakeBet.dispatch(1)
    }
    if(this.playerState2.b > 0 && ps.b2 == 0) {
      Signals.setMakeBet.dispatch(2)
    }

    this.playersState = ps
  }

  roundStart() {
    if(this.playerState1.b > 0) {
      if(this.lastUpdateRoundStart > this.playerState1.u) {
        this.playerState1.c = true
      }
      Signals.setBetStatus.dispatch({side: 1, ps: this._playerState1})
    } else {
      Signals.setMakeBet.dispatch(1)
    }

    if(this.playerState2.b > 0) {
      if(this.lastUpdateRoundStart > this.playerState2.u) {
        this.playerState2.c = true
      }
      Signals.setBetStatus.dispatch({side: 2, ps: this._playerState2})
    } else {
      Signals.setMakeBet.dispatch(2)
    }

    if(this.bonusesTimers.length == 0 && this.bonuses?.length > 0) {
      this.initBonuses()
    }

    if(this.freebets) {
      let event = new CustomEvent("freebets", {detail: {value: this.freebets}})
      document.dispatchEvent(event)
    }
  }

  initBonuses() {
    this.currentBonusIndex = 0
    for (let i = 0; i < this.bonuses.length; i++) {
      if(Facade.syncTime.time > this.bonuses[i].t) {
        if(this.bonuses[i].tp == 'multiplier') {
          this.bonusMultiplier  *= this.bonuses[i].v
          this.currentBonusIndex = i + 1
        }

        if(this.bonuses[i].tp == 'freebet') {
          this.currentFreebetsValue  += this.bonuses[i].v
          this.currentBonusIndex = i + 1
        }
        continue
      }

      let delay = (this.bonuses[i].t - Facade.syncTime.time) - 4000
      if(delay > 4000) {
        delay -= 4000
      } else {
        delay = 0
      }
      // console.log('FEATURE will be in', delay / 1000)
      // TODO: FEATURE IS STOPPED HERE.
      // const timer = setTimeout(() => {
      //   this.stateMachine.setState(GameStatesEnum.START_FEATURE)
      // }, delay)
      // this.bonusesTimers.push(timer)
    }

    //Signals.showfreebets.dispatch(this.currentFreebetsValue)
  }

  roundEnd() {
    this.bonusMultiplier = 1
    this.currentFreebetsValue = 0

    if(this.playerState1.b > 0) {
      if(this.playerState1.c && this.playerState1.u < this.lastUpdateTime) {
        this.playerState1.b = 0
        Signals.setMakeBet.dispatch(1)
      }
    }

    if(this.playerState2.b > 0) {
      if(this.playerState2.c && this.playerState2.u < this.lastUpdateTime) {
        this.playerState2.b = 0
        Signals.setMakeBet.dispatch(2)
      }
    }

    if(this.bonusesTimers?.length > 0) {
      for (let i = 0; i < this.bonusesTimers.length; i++) {
        clearTimeout(this.bonusesTimers[i])
      }

    }
    this.bonuses.length = 0
    this.bonusesTimers.length = 0
  }

  /*
  For reactUI
   */
  bets(data) {
    const arr = (data.bts).filter(bet => bet.ct === this.casinoToken)
    const o = {}

    for (let i = 0; i < arr.length; i++) {
      o[arr[i].i] = arr[i]
    }

    const newArr = Object.values(o)

    Signals.betsUpdates.dispatch(data)

    for (let i = 0; i < newArr.length; i++) {
      if(newArr[i].w) {
        if(data.i == Facade.model.betId1 || data.i == Facade.model.betId2) {
          Signals.playerWin.dispatch(newArr[i])
        }
        Signals.playerTakeWin.dispatch(newArr[i])
      }
    }
  }

  bonusApplied(data) {
    this.bonusTime = data.t

    Signals.featureServerHappened.dispatch()
  }

  set multipliersHistory(value) {
    this._multipliersHistory = value
    Signals.multipliersHistory.dispatch(this.multipliersHistory)
  }

  get multipliersHistory() {
    return this._multipliersHistory
  }

  set bonuses(value) {
    this._bonuses = value

    console.log('bonuses',value)
  }

  get bonuses() {
    return this._bonuses
  }

  get totalWin () {
    return this._totalWin
  }

  set totalWin (value) {
    this._totalWin = value
  }

  get freebets () {
    return this._freebets
  }

  set freebets (value) {
    this._freebets = value

    let event = new CustomEvent("freebets", { detail: {value: value}})
    document.dispatchEvent(event)
  }

  get screenBets () {
    return this._screenBets
  }

  set screenBets (value) {
    this.screenBetsX = []
    for (let i = 0; i < value.length; i++) {
      this.screenBetsX.push(FormatData.formatToCoinsToFixed(value[i], 0))
    }
    this._screenBets = value
  }

}
